import moment from "moment";

export function GenerateSocialSecurityNumber(project) {
  if (
    !project ||
    !project.contact ||
    !project.contact.user ||
    !project.contact.telecoms
  ) {
    console.warn("Missing required project data");
    return null;
  }

  const genderCode = project.contact.user.gender === "F" ? "2" : "1";

  const birthDate = moment(project.contact.user.birthDate);
  const year = birthDate.format("YY");
  const month = birthDate.format("MM");

  const rawDepartment = project.contact.telecoms.find(
    (t) => t.system === "DEPARTMENT_OF_BIRTH"
  )?.value;

  if (!rawDepartment) {
    console.warn("Missing DEPARTMENT_OF_BIRTH");
    return null;
  }

  const department = /^\d{2}$/.test(rawDepartment)
    ? rawDepartment
    : rawDepartment.toLowerCase() === "rhone"
    ? "69"
    : "99"; // fallback

  const communeCode = "123"; 
  const serial = "456"; 

  const nirWithoutKey = `${genderCode}${year}${month}${department}${communeCode}${serial}`;
  const controlKey = String(
    97 - (parseInt(nirWithoutKey, 10) % 97)
  ).padStart(2, "0");

  return `${nirWithoutKey}${controlKey}`;
}
